import React from 'react';
import { createRoot } from 'react-dom/client';
import { Main } from './Main';
import reportWebVitals from './reportWebVitals';
import './common/services/i18next';

document.documentElement.setAttribute('data-theme', 'dark');
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
